<template>
  <div>
    <van-popup round v-model="showTag" @closed="onClosed" :close-on-click-overlay="false" :close-on-popstate="true">
      <div class="pt15 pb15 flex column flex-center flex-center-2 pl15 pr15" style="width: 80vw;">
        <img src="../../assets/dialog/警示.png" alt="">
        <h3 class="fs18 fw600 mt30">{{ title }}</h3>
        <p class="mt30 mb30 color_999">{{ message }}</p>
        <van-button type="info" @click="onConfirm" round block>{{ confirmBtnText }}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "common-error-dialog",
  props: {
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    confirmBtnText: {
      type: String,
      default: "确定"
    }
  },
  data() {
    return {
      showTag: false
    }
  },
  methods: {
    onClosed() {
      this.close();
      this.$emit("closed");
    },

    onConfirm() {
      this.close();
      this.$emit("confirm");
    },

    open() {
      this.showTag = true;
    },


    close() {
      this.showTag = false;
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/plugins/dialog/common-error-dialog.vue